if (!customElements.get("popular-products-carousel")) {
	class PopularProductsCarousel extends HTMLElement {
		connectedCallback() {
			if (typeof Swiper === "undefined") {
				window.addEventListener("load", () => this.init(), { once: true });
				return;
			}
			this.init();
		}

		init() {
			if (this.swiper || typeof Swiper === "undefined") return;

			const columns = parseInt(this.dataset.columns, 10) || 4;
			const columnsMobile = parseInt(this.dataset.columnsMobile, 10) || 1;
			const perView = (max) => Math.min(columns, max);

			this.swiper = new Swiper(this.querySelector(".js-popular-products-swiper"), {
				slidesPerView: columnsMobile + 0.2,
				spaceBetween: 12,
				watchOverflow: true,
				breakpoints: {
					576: { slidesPerView: perView(2), spaceBetween: 16 },
					990: { slidesPerView: perView(3), spaceBetween: 16 },
					1024: { slidesPerView: perView(4), spaceBetween: 16 },
					1360: { slidesPerView: perView(5), spaceBetween: 16 },
					1440: { slidesPerView: perView(5), spaceBetween: 20 },
					1600: { slidesPerView: perView(6), spaceBetween: 20 },
				},
			});
		}

		disconnectedCallback() {
			if (this.swiper) {
				this.swiper.destroy(true, true);
				this.swiper = null;
			}
		}
	}

	customElements.define("popular-products-carousel", PopularProductsCarousel);
}
